import React, {useState, useEffect, useRef, useContext} from 'react';
import {Col, Container, Form, FormControl, InputGroup, Modal, Row} from "react-bootstrap";
import {VALIDATION_IN_JS} from "../../utils/Constants";
import {WEB_ANNOUNCEMENTS_UPDATE_URL} from "../../service/UrlConstant";
import {SecurityContext} from "../../context/security";


export default  function EditAnnouncementModal(props){
    const [editAnnouncement, setEditAnnouncement] = useState({header: '', content: '', notification: ''})
    const [formErrors, setFormErrors] = useState({})
    const headerTextRef = useRef(null)
    const {makePutRequest} = useContext(SecurityContext);

    const handleEditClose = () =>{
        props.setShow(false);
        props.setShowEdit(false);
        setFormErrors({});
    }

    const handleOnChange = (e)=>{
        const {name, value, type, checked} = e.target;
        setEditAnnouncement((prevState=>({
            ...prevState,
            [name]: type === 'checkbox' ? checked: value,
        })))
        setFormErrors(prevFormErrors=>{
            const {[name]: _, ...otherFormErrors} = prevFormErrors;
            return otherFormErrors;
        })
    }


    useEffect(()=>{
        if(props.selectedAnnouncement){
            const isAlert = props.selectedAnnouncement.header.toLowerCase().startsWith('alert');
            setEditAnnouncement((prevState=>({
                ...prevState,
                header: isAlert ? props.selectedAnnouncement.header.substring(6):
                    props.selectedAnnouncement.header,
                content: props.selectedAnnouncement.content,
                notification: isAlert? 'Alert': 'Notification',

            })))

            if(headerTextRef.current) {
                const length = props.selectedAnnouncement.length;
                headerTextRef.current.focus();
                headerTextRef.current.setSelectionRange(length, length);
            }
        }
    },[props.selectedAnnouncement])


    const editAnnouncementHandler = (e)=>{
        e.preventDefault();
        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = props.validateSubmission(formErrors, editAnnouncement);
        }

        setFormErrors(errors);

        if(Object.keys(errors) != 0)
            return

        const onSuccess = (response) => {
            props.setShow(false)
            props.setShowEdit(false)
            if(response.data) {
                const updatedAnnouncements = props.announcements.map((announcement)=>{
                    return response.data.announcementId === announcement.announcementId?
                        {...announcement,
                            header: response.data.header,
                            content: response.data.content,
                            notification: response.data.notification
                             } : announcement;
                })

                props.setAnnouncements(updatedAnnouncements);
            }
        }
        const onError = (err) => {
            console.error(err);
        }


        const editParams = {
            announcementId: props.selectedAnnouncement.announcementId,
            header:editAnnouncement.notification === 'Alert'? `ALERT: ${editAnnouncement.header}`:
                editAnnouncement.header,
            content: editAnnouncement.content,
            position: props.selectedAnnouncement.position
        }

        makePutRequest(editParams, WEB_ANNOUNCEMENTS_UPDATE_URL, onSuccess, onError)

    }


    return (<div className='p-8'>
        <Modal
            show={props.show &&  props.showEdit}
            onHide={handleEditClose}
            animation={false}
            className='pb-0' id='edit-modal'
            backdrop='static'
        >
            <Modal.Header closeButton
                          style={{textAlign: 'right', border:'none', alignSelf:'flex-end'}} className='pb-0'>
            </Modal.Header>
            <Container className="mt-md-3 mt-sm-0 pb-4 pt-0">
                <Form className={'mt-0'} onSubmit={(e) => editAnnouncementHandler(e)} >
                    <Col>
                        <h2 className='mb-4'>Edit Notification</h2>
                    </Col>
                    <Col xs={12} sm={12} md={12} className={'py-0'}>
                        <Form.Group controlId="formGridSecurity">
                            <label className='my-0'>Header *</label>
                            <InputGroup>
                                <FormControl
                                    ref={headerTextRef}
                                    className='pl-3 rounded'
                                    as="textarea"
                                    value={editAnnouncement.header}
                                    name='header'
                                    onChange={handleOnChange}
                                    isInvalid={!!formErrors.header}
                                    style={{
                                        height:'70px',
                                        fontSize: '16px',
                                        fontWeight: 'light',
                                        fontFamily : 'TD Graphik SemiLight'
                                    }}

                                />
                                <Form.Control.Feedback type={"invalid"}>
                                    <b>
                                        <i className="bi bi-exclamation-circle">
                                        </i>{formErrors.header}
                                    </b>
                                </Form.Control.Feedback>
                            </InputGroup>
                            <span className='mt-2 d-block'>0/250</span>
                        </Form.Group>
                    </Col>

                    <Col xs={12} sm={12} md={12} className={'py-0'}>
                        <Form.Group controlId="formGridSecurity">
                            <label className='my-0'>Body *</label>
                            <InputGroup>
                                <FormControl className='pl-3 rounded'
                                             as="textarea"
                                             value={editAnnouncement.content}
                                             name='content'
                                             onChange={handleOnChange}
                                            isInvalid={!!formErrors.content}
                                             style={{
                                                 height:'85px',
                                                 fontSize: '16px',
                                                 fontWeight: 'light',
                                                 fontFamily : 'TD Graphik SemiLight'
                                             }}
                                />
                                <Form.Control.Feedback type={"invalid"}>
                                    <b>
                                        <i className="bi bi-exclamation-circle">
                                        </i>{formErrors.content}
                                    </b>
                                </Form.Control.Feedback>
                            </InputGroup>
                            <span className='mt-2 d-block'>0/250</span>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Alert"
                                name="notification"
                                type="radio"
                                className='mr-8'
                                value="Alert"
                                isInvalid={!!formErrors.notification}
                                onChange={handleOnChange}
                                checked={editAnnouncement.notification === 'Alert'}
                                id='Alert'
                            />
                            <Form.Check
                                inline
                                label="Notification"
                                name="notification"
                                type='radio'
                                className='ml-sm-4'
                                value="Notification"
                                onChange={handleOnChange}
                                isInvalid={!!formErrors.notification}
                                checked={editAnnouncement.notification === 'Notification'}
                                id='Notification'
                            />
                            {formErrors.notification &&
                                <Form.Control.Feedback type={"invalid"} style={{display: 'block'}}>
                                    <b>
                                        <i className="bi bi-exclamation-circle">
                                        </i>
                                        {formErrors.notification}
                                    </b>
                                </Form.Control.Feedback>}
                        </Form.Group>

                    </Col>
                    <Col>
                        <Row className='pr-5 pl-5'>
                            <Col md={6}>
                                <button className="btn btn-block td-btn-secondary-clear my-3" onClick={()=>{
                                    props.setShow(false);
                                    props.setShowEdit(false);
                                }}>Cancel</button>
                            </Col>
                            <Col md={6}>
                                <button className="btn btn-block td-btn-primary-light my-3">Update</button>
                            </Col>
                        </Row>
                    </Col>
                </Form>
            </Container>
        </Modal>
    </div>)

}